module.exports = __webpack_public_path__ + "static/testi-3-11f44d1dc96ce30b4aeb66cc69d296fb.jpg";